<template>
  <div id="roomList">
    <!-- nav -->
    <navbar></navbar>
    <div class="container mt-4">
      <!-- form -->
      <b-card title="新しいゲームを作成する">
        <b-form class="col" @submit.prevent="onCreateGame">
          <b-form-group label="ゲームタイトル" label-for="pageInput">
            <b-form-input
              type="text"
              id="pageInput"
              v-model="createGameForm.title"
              placeholder="好きなゲーム名"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="説明" label-for="desInput">
            <b-form-input
              type="text"
              id="desInput"
              v-model="createGameForm.description"
              placeholder
            ></b-form-input>
          </b-form-group>

          <div class="d-flex flex-row-reverse">
            <b-button type="submit" variant="primary" class="mr-1">作成</b-button>
          </div>
        </b-form>
      </b-card>
    </div>
  </div>
</template>

<script>
import { createGame } from "../graphql/mutations";
import { graphqlQuery } from "../util/queryUtil";
import Navbar from "@/components/Navbar.vue";

export default {
  components: { Navbar },
  data() {
    return {
      createGameForm: { title: "", description: "" }
    };
  },
  methods: {
    onCreateGame() {
      graphqlQuery(
        this,
        createGame,
        {
          input: Object.assign({}, this.createGameForm, {
            cards: [],
            characters: [],
            fieldTags: ["犯行現場", "庭", "部屋"]
          })
        },
        result => {
          //   console.log(result);
          this.$router.push("/game/" + result.data.createGame.id);
        }
      );
    }
  },
  computed: {}
};
</script>
